// extracted by mini-css-extract-plugin
export default {"button":"CartAddReomveItemButton_button__xOKr1"};